import ApiConstants from "../constants/ApiConstants";
import http from "../http";
import Utility from "../utility/Utility";

export const API_CONFIG = {
    page: 1,
    limit: 20
}

export class CompoffService {

    static initailizedApiConfig;
    static appliedCompOffApiConfig;
    static requestCompoffApiConfig;

    static fetchConfigurationSettings() {
        const url = ApiConstants.URL.COMP_OFF.FETCH_CONFIGURATION;
        return http.get(url);
    }

    static postConfigurationSettings(body) {
        const url = ApiConstants.URL.COMP_OFF.POST_CONFIGURATION;
        return http.post(url, body);
    }

    static updateConfigurationSettings(body) {
        const url = ApiConstants.URL.COMP_OFF.UPDATE_CONFIGURATION;
        return http.put(url, body);
    }

    static fetchInitializedCompOffs() {
        const url = ApiConstants.URL.COMP_OFF.FETCH_CONFIGURATION;
        return http.get(url);
    }

    static postInitialisedCompoff(body) {
        const url = ApiConstants.URL.COMP_OFF.SAVE_INITIALIZED_COMPOFF;
        return http.post(url, body);
    }

    static updateInitialisedCompoff(body) {
        const url = ApiConstants.URL.COMP_OFF.UPDATE_INITIALIZED_COMPOFF;
        return http.put(url, body);
    }

    static updateEmployeeCompOffStatus(body) {
        const url = ApiConstants.URL.COMP_OFF.UPDATE_EMPLOYEE_APPLIED_COMP_OFF_STATUS;
        return http.put(url, body);
    }

    static getInitialisedCompoffsList() {
        const url = ApiConstants.URL.COMP_OFF.GET_INITIALITED_COMPOFF_LIST;
        return http.post(url, CompoffService.initailizedApiConfig);
    }

    static getAlreadyExistCompoffsList(body) {
        const url = ApiConstants.URL.COMP_OFF.GET_INITIALITED_COMPOFF_LIST;
        return http.post(url, body);
    }

    static deleteInitialisedCompoffs(body) {
        const url = ApiConstants.URL.COMP_OFF.DELETE_INITIALISED_COMP_OFFS;
        return http.delete(url, {data : body})
    }

    static getEmployeeCompOffsList() {
        const url = ApiConstants.URL.COMP_OFF.EMPLOYEE_APPLIED_COMP_OFF_FILTER;
        return http.post(url, CompoffService.requestCompoffApiConfig);
    }

    static getEmployeeAppliedCompOffsList() {
        const url = ApiConstants.URL.COMP_OFF.EMPLOYEE_APPLIED_COMP_OFF_FILTER;
        if(Utility.isEmpty(CompoffService.appliedCompOffApiConfig)) {
            CompoffService.appliedCompOffApiConfig = API_CONFIG
        }
        return http.post(url, CompoffService.appliedCompOffApiConfig);
    }

    static deleteRequestCompoffs(body) {
        const url = ApiConstants.URL.COMP_OFF.EMPLOYEE_APPLIED_COMP_OFF;
        return http.delete(url, {data : body})
    }
    static getEmployeeCompOffsForCondition(param) {
        const url = ApiConstants.URL.COMP_OFF.EMPLOYEE_APPLIED_COMP_OFF_FILTER;
        
        return http.post(url, param);
    }
    static getCompOffByUserId(id) {
        const url = ApiConstants.URL.COMP_OFF.GET_BY_USER_ID(id);
        return http.get(url);
    }
    static applyCompOff(data,isEdit) {
        const url = ApiConstants.URL.COMP_OFF.SAVE_EMPLOYEE_COMP_OFF;
        if(isEdit) {
            return http.put(url,data);
        } else {
            return http.post(url,data);
        }
    }
    static deleteAppliedCompOff(data) {
        const url = ApiConstants.URL.COMP_OFF.SAVE_EMPLOYEE_COMP_OFF;
        return http.delete(url,{data:data})
    }
    static getLeaveDetail(data) {
        const url = ApiConstants.URL.COMP_OFF.LEAVE_DETAILS;
        return http.get(url,{params:data});
    }
    static getLeaveTypes(params) {
        return http.get(ApiConstants.URL.COMP_OFF.LEAVES, {params:params});
    }
}
